import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcOutlinedBtnIconComponent } from './svc-outlined-btn-icon.component';

@NgModule({
  declarations: [
    SvcOutlinedBtnIconComponent
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    NgClass,
  ],
  exports: [
    SvcOutlinedBtnIconComponent
  ]
})
export class SvcOutlinedBtnIconModule { }
